import { createRef, cloneElement, Fragment, Component } from 'react';
import { getCookie, setCookie } from '../../../../utils/cookie';

export default class EducationalTooltip extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: props.id ? !getCookie(props.id) : false,
    };
    this.tooltip = createRef();
  }

  clonedChildren() {
    return cloneElement(this.props.children, {
      ...this.props.children.props,
      onClick: () => this.toogleTooltip(),
    });
  }

  onClick() {
    if (!this.props.id) return;
    this.setState({ visible: false }, () => {
      setCookie(this.props.id);
    });
  }

  toogleTooltip() {
    if (this.props.id) return;
    this.setState({
      visible: !this.state.visible,
    });
  }

  render() {
    let { children } = this.props;
    return (
      <Fragment>
        {this.props.id ? children : this.clonedChildren()}
        {this.state.visible ? (
          <div
            onClick={() => this.onClick()}
            className="educational-tooltip"
            ref={this.tooltip}
          >
            <div className="tooltip-tip"></div>
            <div className="message">
              <div
                dangerouslySetInnerHTML={{ __html: this.props.message }}
              ></div>
              <span className="close"></span>
            </div>
          </div>
        ) : null}
      </Fragment>
    );
  }
}
